<template>
  <div class="seller-view">
    <NavbarMain class="sell" />
    <div class="container">
      <div
        class="row justify-content-center align-items-center py-5 mt-3"
        v-if="this.auth.posicion != 'Usuario'"
      >
        <div class="col-12 mb-5">
          <h2 class="text-center">¿Qué desea vender?</h2>
        </div>
        <div class="col-6">
          <router-link
            class="btn btn-block btn-treid text-uppercase"
            :to="{name: 'SellerProduct'}"
          >Un producto</router-link>
        </div>
        <div class="col-6">
          <router-link
            class="btn btn-block btn-treid text-uppercase"
            :to="{name: 'SellService'}"
          >Un servicio</router-link>
        </div>
      </div>
      <div
        class="row justify-content-center align-items-center py-5 mt-3"
        v-if="this.auth.posicion == 'Usuario'"
      >
        <div class="col-12 mb-5">
          <h2 class="text-center">Todavía no tienes permiso para vender productos.</h2>
          <div class="text-center mt-5">
            <span class="material-icons text-danger" style="font-size: 10em">sentiment_very_dissatisfied</span>
          </div>
          <h4 class="text-center mt-5">La posición mínima autorizada es "Representante" y todavía eres "Usuario".</h4>
          <h6 class="text-center">Podrá subir a dicha posición a "Representante" en Sistema Apple.</h6>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavbarMain from "@/components/NavbarMain.vue";
import { mapState } from "vuex";

export default {
  name: "Sell",
  components: {
    NavbarMain,
  },
  data() {
    return {
      name: "",
      price: 0,
      discount: 0,
      images: [],
      description: "",
      categories: [],
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  created: async function () {

  },
};
</script>

<style scoped lang="sass">
.opt
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
</style>

<style lang="scss" scoped>
footer {
  position: absolute;
}

.seller-view {
  height: 100%;
}
</style>